<template>
  <div class="g-wrapper g-vertical-block">
    <div class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="plandataccount" label="账号"></TabPane>
            <TabPane name="plandatadetail" label="计划"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <keep-alive :max="5">
          <router-view />
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'plandata',
  data() {
    return {
      currentRoute: ''
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      this.currentRoute = this.$route.name
      if (this.$route.name === 'plandata') this.changeRouter('plandatadetail')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  height: calc(100% - 37px);
  position: relative;
}
</style>
